export default {
  header: {
    login: 'Se connecter',
    freeTrial: 'Tester gratuitement',
  },
  share: {
    title: 'Partagez vos fichiers',
    subtitle: 'Un lien privé, prêt à envoyer — aucun téléchargement pour le regarder.',
  },
  freeTier: {
    note: 'Gratuit · sans compte · jusqu’à 2 Go · vidéo 10 min · liens 7 jours',
  },
  prepare: {
    file: '{count} fichier | {count} fichiers',
    filesTitle: 'Fichiers',
    addMore: 'Ajouter des fichiers',
    send: 'Envoyer',
    uploading: 'Envoi… {progress}%',
    uploadFailed: "Échec de l'envoi",
    retry: "Réessayer l'envoi",
    remove: 'Retirer le fichier',
  },
  form: {
    tabLink: 'Lien',
    tabEmail: 'E-mail',
    createLink: 'Créer le lien',
    shareName: 'Nom du partage (optionnel)',
    shareNamePlaceholder: 'Ex : Photos projet',
    shareTitle: 'Titre du partage',
    shareTitlePlaceholder: 'Ex : Photos projet 2026',
    emailSoon: "L'envoi par e-mail arrive bientôt — partagez le lien pour l'instant.",
  },
  link: {
    copy: 'Copier le lien',
    copied: 'Copié !',
    open: 'Ouvrir',
  },
  settings: {
    noPassword: 'Aucun mot de passe',
    withPassword: 'Protégé par mot de passe',
    expirationLabel: 'Expiration',
    expirationHint: 'Les liens gratuits durent jusqu’à 7 jours.',
    passwordLabel: 'Protection par mot de passe',
    passwordHint: 'Exiger un mot de passe pour ouvrir le lien.',
    downloadLabel: 'Téléchargement autorisé',
    downloadHint: 'Désactivé = visionnage seul, dans le lecteur.',
    passwordPlaceholder: 'Définir un mot de passe',
    passwordMinLength: 'Utilisez au moins 4 caractères.',
    expiration: {
      '1': '1 jour',
      '3': '3 jours',
      '7': '7 jours',
    },
    accountBadge: 'Compte',
    emailSend: 'Envoyer par e-mail',
    emailSendHint: 'Envoyez ce partage directement à vos contacts.',
    longer: 'Garder les liens plus longtemps',
    longerHint: 'Choisissez la durée — vos fichiers n’expirent jamais tout seuls.',
    stats: 'Voir qui a regardé',
    statsHint: 'Suivez vues et téléchargements en temps réel.',
  },
  success: {
    upsellTitle: 'Créez un compte gratuit pour aller plus loin',
    upsellSubtitle: 'Voir qui a regardé · garder les liens au-delà de 7 jours · lever les limites',
    upsellCta: 'Créer mon compte gratuit',
  },
  loading: {
    link: 'Création de votre lien…',
    email: 'Envoi en cours…',
    linkSub: 'On sécurise votre partage et on prépare votre lien.',
    emailSub: "On prépare l'envoi à vos destinataires.",
  },
  result: {
    titleLink: 'Votre lien est prêt',
    titleEmail: 'Emails envoyés',
    justNow: "à l'instant",
    sentTo: 'Envoyé à',
    expiration: 'Expiration',
    noExpiration: 'Sans expiration',
    views: 'Vues & historique',
    viewsGated: 'Avec un compte',
    access: 'Accès',
    accessPublic: 'Public',
    accessProtected: 'Mot de passe',
    download: 'Téléchargement',
    downloadOn: 'Autorisé',
    downloadOff: 'Visionnage seul',
    shareVia: 'Partager via',
    shareText: 'Je vous partage des fichiers avec Videas',
    shareSubject: 'Fichiers partagés avec Videas',
    qrLabel: 'Scannez ce QR code pour ouvrir le partage sur un téléphone.',
    newShare: 'Nouveau partage',
  },
  demo: {
    title: 'Ceci est une démo',
    message: 'Créez un compte Videas gratuit pour partager vos fichiers en toute sécurité.',
    cta: 'Essayer gratuitement',
  },
  errors: {
    createFailed: 'La création du lien a échoué. Veuillez réessayer.',
    tooLarge: '{name} dépasse la limite de 2 Go (offre gratuite).',
    tooLong: '{name} dépasse la limite de 10 min (offre gratuite).',
  },
  empty: {
    title: 'Partagez vos fichiers en toute sécurité',
    subtitle: 'Envoyez vos fichiers pour commencer.',
  },
  subtitles: {
    transcribing: {
      title: 'Génération de vos sous-titres…',
      subtitle: 'Notre IA transcrit {name}.',
      note: 'Pas besoin de compte pour voir le résultat',
      steps: {
        received: 'Réception du fichier',
        audio: 'Extraction de la piste audio',
        transcript: 'Transcription et calage des mots',
        cues: 'Découpage en sous-titres',
      },
      eta: 'Encore {time} environ',
      etaSeconds: '{count} s',
      etaMinutes: '{count} min',
      etaUnknown: 'Estimation du temps restant…',
    },
    editing: {
      translate: 'Traduire',
      export: 'Exporter',
      createAccount: 'Créer mon compte',
    },
    gate: {
      export: {
        title: 'Créez votre compte pour télécharger',
      },
      translate: {
        title: 'Créez votre compte pour traduire',
      },
      subtitle: 'Gratuit, en 30 secondes. Vos sous-titres édités vous suivent.',
      features: {
        downloadLead: 'Téléchargez',
        downloadText: 'vos sous-titres en SRT, VTT, TXT et DOCX',
        translateLead: 'Traduisez',
        translateText: 'en plus de 100 langues en une passe',
        keepLead: 'Conservez & publiez',
        keepText: '— sous-titres incrustés dans le player Videas',
      },
      keep: 'Votre travail sur « {name} » est conservé et rattaché à votre compte.',
      defaultFile: 'votre fichier',
      cta: 'Créer mon compte gratuit',
      haveAccount: 'Déjà un compte ?',
      login: 'Se connecter',
      later: 'Continuer à éditer',
    },
    nospeech: {
      title: 'Ce fichier ne contient pas de parole',
      message:
        'Nous n’avons rien trouvé à transcrire : le fichier est muet, ou ne contient aucune parole. Vérifiez qu’il a bien une piste audio, puis réessayez.',
      cta: 'Essayer un autre fichier',
    },
    error: {
      title: 'Une erreur est survenue',
      message: 'Nous n’avons pas pu générer les sous-titres de ce fichier.',
      retry: 'Essayer un autre fichier',
    },
    timeout: {
      title: 'Toujours en cours',
      message: 'Cela prend plus de temps que d’habitude. Vous pouvez patienter ou revenir dans un instant.',
      keepWaiting: 'Continuer à patienter',
    },
    nodata: {
      title: 'Aucun fichier à sous-titrer',
      subtitle: 'Importez une vidéo pour obtenir des sous-titres automatiques.',
      cta: 'Commencer',
    },
  },
}
